import "../Challenges.css"
import React, { useState,useEffect } from "react";
import "../../myProjects/Myprojects.css"
import { FaRegWindowClose } from "react-icons/fa";
import CustomDropdown from "../../../../components/DropdownClass";
import  { API_BASE_URL } from '../../../../configs/AppConfig';
import api from "views/auth/Api";
import { jwtDecode } from "jwt-decode";




const ChallengesAssign = ({popUpAssign, onClose,grade}) => {

        const [cardId, setCardId] = useState("");
        const [classes , setClasses] = useState([]);
        const [formInputs , setFormInputs] = useState({
          points:"",
          teamSize:"",
          class: "",
        });

        const token = localStorage.getItem('token');
        const decoded = jwtDecode(token);
        const role = decoded.role

        const isFormValid = formInputs.points !== '' && formInputs.teamSize !== ''
          && formInputs.class !== '' && formInputs.dueDate !== '';
            
      
useEffect(() => {
  if (role === "Teacher")
     api.get(`${API_BASE_URL}class/grade/${grade}`)
      .then((response) => {  
        setClasses(response.data);
        console.log("classes",response.data);
      })
      .catch((error) => {
        console.error('Error fetching card:', error);
      });
  }, [grade,role]);

    const handleSubmit = (event) => {
    event.preventDefault();
    popUpAssign([formInputs.teamSize , formInputs.points, formInputs.class, formInputs.dueDate]);
      // assignChallange();
      setFormInputs({
          class:"",
          points:"",
          teamSize:"",
          dueDate:""
        })   
    }
        // const assignChallange = async()=>{
        //   await api.post(`${API_BASE_URL}assigned-challenge`,{
        //   points: formInputs.points.trim(),
        //   teamSize: formInputs.teamSize.trim(),
        //   class: "A",
        //   })
        // .then(function (response) {
        //           console.log("handlesubmitffff  ", response.data)
        //       // setData(response.data)
        // }).catch(error => {
        //   console.log("handlesubmit error for blog get ", error)
        // });
        // }  
const selectedClass = (classId) => {
  setFormInputs({...formInputs, class: classId});
}

  return (
     <form className="teacherModal" onSubmit={handleSubmit}>
        <div className="popUpAssign">
          <FaRegWindowClose className="windowClose" onClick={() => onClose()} />
           <h4>Assign to student</h4>
          {/* <div className="filterByBtn fliterMarOver">
            <MdOutlineSchool className="filterByicon"/>
            <span>Filter by class</span>
            <div className="dropdownImg"></div>
          </div> */}
          <div className="mb-[15px]">
      <CustomDropdown options={classes}
       selectedd={selectedClass}
       type="Select Class"
       />
       </div>
           {/* <div className="popUpCreateTeam">
            <span>Create Team</span>
            <div className="createSwip">
              <div></div>
            </div>
           </div> */}
           <div className="popUpTeamSize">
            <span>Team Size</span>
            <input type="number" className="inputWidth" value={formInputs.teamSize} placeholder="Enter Team Size" 
            onChange={(e) =>setFormInputs({...formInputs, teamSize: e.target.value})}/>
           </div>
            <div className="popUpTeamSize">
            <span>Points</span>
            <input type="number" className="inputWidth" value={formInputs.points} placeholder="Enter Challenge Points" 
            onChange={(e) =>setFormInputs({...formInputs, points: e.target.value})}/>
           </div>
           <div className="popUpTeamSize">
            <span>Due date</span>
            <input type="date"  id="dueDate" name="dueDate" className="inputWidth inputWidthS" value={formInputs.dueDate}
             onChange={(e) =>setFormInputs({...formInputs, dueDate: e.target.value})}/>
          </div>

           <button type="submit" disabled={!isFormValid} className="add-Challenge">Assign</button>
          </div>
        </form>
     
  );
};

export default ChallengesAssign;
